module.exports = __webpack_public_path__ + "static/media/Logo.d465f1c7.webp";